import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/account/business-hour",

        async list() {
            const url = this.url();

            return await Vue.http.get(url);
        },

        async getOne({dayOfWeek}) {
            const url = this.url(`/${dayOfWeek}`);

            return await Vue.http.get(url);
        },

        async edit({dayOfWeek, isActiveDay, openingTime, closingTime, limitCaptiveToPeriod}) {
            const url = this.url();

            return await Vue.http.put(url, {
                dayOfWeek,
                isActiveDay,
                openingTime,
                closingTime,
                limitCaptiveToPeriod
            });
        },

    },
    base
);
